import { useLoadingIndicator, type UseLoadingIndicatorOptions } from "./useLoadingIndicator.tsx";

export interface UseSkeletonStateOptions<T> extends UseLoadingIndicatorOptions {
    isPending: boolean;
    data: T[] | undefined;
    placeholder: T[];
}

export interface UseSkeletonStateResult<T> {
    items: T[];
    hasContent: boolean;
    isLoading: boolean;
    isEmpty: boolean;
}

export function useSkeletonState<T>({ isPending, data, placeholder, ...delayOptions }: UseSkeletonStateOptions<T>): UseSkeletonStateResult<T> {
    const isLoading = useLoadingIndicator(isPending, delayOptions);

    const isInDelayWindow = isPending && !isLoading;
    const items = isLoading ? placeholder : (data ?? placeholder);
    const hasContent = !isInDelayWindow && items.length > 0;
    const isEmpty = !isLoading && data?.length === 0;

    return { items, hasContent, isLoading, isEmpty };
}
